var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageinfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6575 12230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,1a6,6,0,1,0,6,6A6.007,6.007,0,0,0,7,1M7,0A7,7,0,1,1,0,7,7,7,0,0,1,7,0Z",
    transform: "translate(-6575 -12230)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 6,
    rx: 0.5,
    transform: "translate(-6568.5 -12225)",
    fill: "#26B963"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 1,
    rx: 0.5,
    transform: "translate(-6568.5 -12227)",
    fill: "#26B963"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageinfo);
export default __webpack_public_path__ + "static/media/messageinfo.5e34478aa378a8728e00a4dd58f86346.svg";
export { ForwardRef as ReactComponent };